import {
	AlphanumericSupport,
	ServiceProvider,
	VoiceConnectivityMethod,
} from "./../../common/enum";

export default class CountryModel {
	public id: string;
	public countryCodeISO: string;
	public twilioAccountSid: string;
	public twilioAuthToken: string;
	public azureResourceGroupName: string;
	public sharepointSiteId: string;
	public sharepointDriveId: string;
	public flowExclusionList: string[];
	public flagImageName: string;
	public isSMSEnabled: boolean;
	public isOutboundSMS: boolean;
	public isInboundSMS: boolean;
	public alphanumericSupport: AlphanumericSupport;
	public isSenderIdPreserved: boolean;
	public isVoiceEnabled: boolean;
	public voiceConnectivityMethod: VoiceConnectivityMethod;
	public isWhatsappEnabled: boolean;
	public isUSSDEnabled: boolean;
	public isDeleted: boolean;
	public isAddCountryRequest: boolean;
	public africasTalkingUserName: string;
	public africasTalkingApiKey: string;
	public africasTalkingEnabled: boolean;
	public dchEnabled: boolean;
	public dchApiKey: string;
	public dchApiURL: string;
	public dchEnvironment: string;
	public dchCountry: string;
	public whatsappEnabledPhoneNumber: string;
	public serviceProviders: ServiceProvider;
	public vodafoneProviderUserName: string;
	public vodafoneProviderPassword: string;
	public vodafoneApiBaseUrl: string;
	public vodafoneDistributionId: string;
	public vodafoneProviderEnabled: boolean;
	public senderId: string;

	public constructor() {
		this.id = "";
		this.countryCodeISO = "";
		this.flagImageName = "";
		this.twilioAccountSid = "";
		this.twilioAuthToken = "";
		this.azureResourceGroupName = "";
		this.sharepointSiteId = "";
		this.sharepointDriveId = "";
		this.isSMSEnabled = false;
		this.isOutboundSMS = false;
		this.isInboundSMS = false;
		this.isSenderIdPreserved = false;
		this.isVoiceEnabled = false;
		this.isWhatsappEnabled = false;
		this.isUSSDEnabled = false;
		this.isDeleted = false;
		this.flowExclusionList = [];
		this.alphanumericSupport = AlphanumericSupport.None;
		this.voiceConnectivityMethod = VoiceConnectivityMethod.None;
		this.isAddCountryRequest = false;
		this.africasTalkingUserName = "";
		this.africasTalkingApiKey = "";
		this.africasTalkingEnabled = false;
		this.dchEnabled = false;
		this.dchApiKey = "";
		this.dchApiURL = "";
		this.dchEnvironment = "";
		this.dchCountry = "";
		this.whatsappEnabledPhoneNumber = "";
		this.serviceProviders = ServiceProvider.Twilio;
		this.vodafoneProviderUserName = "";
		this.vodafoneProviderPassword = "";
		this.vodafoneApiBaseUrl = "";
		this.vodafoneDistributionId = "";
		this.senderId = "";
		this.vodafoneProviderEnabled = false;
	}
}
